import { Injectable } from '@angular/core';
import { TDCTransaction, TransactionWrapper } from '@core/models';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TransactionService {
  transaction$: BehaviorSubject<TransactionWrapper | null> =
    new BehaviorSubject<TransactionWrapper | null>(null);

  hasRainoutInsurance(): boolean {
    return Boolean(
      this.transaction$.value?.transaction?.tdcTransaction?.hasInsuranceRainout
    );
  }

  getEventId(): number {
    return this.transaction$.value?.transaction?.eventId || 0;
  }

  getTotalSeats(): number {
    return this.transaction$.value?.transaction?.seats?.length || 0;
  }

  getTotalPrice(): number {
    return (
      this.transaction$.value?.transaction?.tdcTransaction?.totalPriceSeats || 0
    );
  }

  getUnitPrice(): number {
    if (!this.transaction$.value?.transaction?.seatsPrices) {
      return 0;
    }
    return (
      Object.values(this.transaction$.value?.transaction?.seatsPrices)?.[0]
        ?.value || 0
    );
  }

  getTransactionUpsell() {
    const buyerTypeId = this.transaction$.value?.transaction?.buyerTypeId;
    return this.transaction$.value?.transaction?.event?.upsells?.find(
      upsell => upsell.buyerTypeId === buyerTypeId
    );
  }

  getInsurancePrice(): number {
    return (
      this.transaction$.value?.transaction?.tdcTransaction
        ?.insuranceRainoutPrice || 0
    );
  }

  getServiceChargesDetails(t: TDCTransaction): {
    name: string;
    amount: number;
  }[] {
    const calculatedServiceCharges = Object.values(
      t.serviceChargesDetails.clientServiceCharges ?? {}
    );

    const calculatedServiceChargesAmount = calculatedServiceCharges.reduce(
      (acc, item) => acc + (item?.total ?? 0),
      0
    );

    const hasNoConfiguredServiceCharges = calculatedServiceChargesAmount === 0;

    if (
      hasNoConfiguredServiceCharges ||
      calculatedServiceChargesAmount > t.serviceCharges
    ) {
      return [{ name: 'Total Taxes & Fees', amount: t.serviceCharges }];
    }

    const result = calculatedServiceCharges.map(item => {
      return { name: item.name, amount: item.total };
    });

    if (calculatedServiceChargesAmount < t.serviceCharges) {
      result.push({
        name: 'Others',
        amount: t.serviceCharges - calculatedServiceChargesAmount,
      });
    }

    return result;
  }
}
